import Stack, { type StackProps } from "@mui/material/Stack";
import { styled } from "../../../../lib/styled";

interface CenteredStackProps extends StackProps {
  $minHeight?: number | string;
  $textAlign?: "center" | "left" | "right";
}

/** Stack centered on both axes with an optional minimum height and text alignment. */
export const CenteredStack = styled(Stack)<CenteredStackProps>(({ $minHeight, $textAlign }) => ({
  alignItems: "center",
  justifyContent: "center",
  ...($minHeight !== undefined && { minHeight: $minHeight }),
  ...($textAlign && { textAlign: $textAlign }),
}));
